import {
  apiConf,
  sendRequest
} from '../config'

/**
 * 查询操作员列表
 */
export const getOperatorsList = (params) => {
  return sendRequest(['GET', '/merchant/acquirer/operator/getOperators'], params)
}
/**
 * 查询角色列表
 */
export const getRoleList = () => {
  return sendRequest(['GET', '/merchant/acquirer/role/getRoles'])
}
/**
 * 角色 - 查询(分页)
 */
export const getPageRoleList = (params) => {
  return sendRequest(['GET', '/merchant/acquirer/role/getPageRoles'], params)
}
/**
 * 新增操作员
 */
export const addOperator = (params) => {
  const machineId = sessionStorage.getItem('machineId') // 机器码ID
  params.machineId = machineId
  return sendRequest(['POST', '/merchant/acquirer/operator/addOperator'], params)
}

/**
 * 删除操作员
 */
export const deleteOperator = (params) => {
  return sendRequest(['POST', '/merchant/acquirer/operator/deleteOperator'], params)
}
/**
 * 操作员 - 操作员修改
 */
export const updateOperator = (params) => {
  const machineId = sessionStorage.getItem('machineId') // 机器码ID
  params.machineId = machineId
  return sendRequest(['POST', '/merchant/acquirer/operator/updateOperator'], params)
}
/**
 * 操作员 - 修改密码
 */
export const changePwd = (params) => {
  const machineId = sessionStorage.getItem('machineId') // 机器码ID
  params.machineId = machineId
  return sendRequest(['POST', '/merchant/acquirer/operator/changePwd'], params, {
    headers: {
      ContentType: 'application/x-www-form-urlencoded'
    }
  })
}

/**
 * 操作员 - 激活禁用操作员
 */
export const updateOperatorStatus = (params) => {
  return sendRequest(['POST', '/merchant/acquirer/operator/updateOperatorStatus'], params, {
    headers: {
      ContentType: 'application/x-www-form-urlencoded'
    }
  })
}
/**
 * 获取所有group
 */
export const getGroupsList = (params) => {
  return sendRequest(['GET', '/merchant/acquirer/operator/getAllGroups'], params, {
    headers: {
      ContentType: 'application/x-www-form-urlencoded'
    }
  })
}
/**
 * 获取所有操作员详情
 */
export const getOperatorDetail = (params) => {
  return sendRequest(['GET', `/merchant/acquirer/operator/getOperatorDetail?operatorCode=${params.operatorCode}`, params])
}
/**
 * 获取角色详情
 */
export const getRoleDetail = (params) => {
  return sendRequest(['GET', '/merchant/acquirer/role/getRoleDetail'], params, {
    headers: {
      ContentType: 'application/x-www-form-urlencoded'
    }
  })
}
/**
 * 获取用户权限
 */
export const getPermissions = () => {
  return sendRequest(['GET', '/merchant/acquirer/role/getPermissions'])
}
/**
 * 获取用户权限树
 */
export const getPermissionsTree = () => {
  return sendRequest(['GET', '/merchant/acquirer/role/getPermissionsTree'])
}
/**
 * 操作员 - 查询（ 根据角色查询）
 */
export const getOperatorsByRole = (params) => {
  return sendRequest(['GET', '/merchant/acquirer/operator/getOperatorsByRole'], params)
}
/**
 * 角色修改（权限分配）
 */
export const updateRolePermission = (params) => {
  return sendRequest(['POST', '/merchant/acquirer/role/updateRolePermission'], params)
}
/**
 * 角色 - 修改（ 基本信息）
 */
export const updateRoleBaseInfo = (params) => {
  return sendRequest(['POST', '/merchant/acquirer/role/updateBaseInfo'], params, {
    headers: {
      ContentType: 'application/x-www-form-urlencoded'
    }
  })
}
/**
 * 角色 - 添加角色
 */
export const addRole = (params) => {
  return sendRequest(['POST', '/merchant/acquirer/role/addRole'], params, {
    headers: {
      ContentType: 'application/x-www-form-urlencoded'
    }
  })
}
/**
 * 角色 - 删除
 */
export const deleteRole = (params) => {
  return sendRequest(['POST', '/merchant/acquirer/role/deleteRole'], params, {
    headers: {
      ContentType: 'application/x-www-form-urlencoded'
    }
  })
}

/**
 * 操作员 - 分配权限
 */
export const assignPermission = (params) => {
  return sendRequest(['POST', '/merchant/acquirer/operator/setRoles'], params, {
    headers: {
      ContentType: 'application/x-www-form-urlencoded'
    }
  })
}
// 获取option
export const fetchOption = (topic) => {
  return sendRequest(['GET', `/common/getEnum?topic=${topic}`])
}
